import { render, staticRenderFns } from "./UnsubscribeEmailPage.vue?vue&type=template&id=99ff9fd6&scoped=true"
import script from "./UnsubscribeEmailPage.vue?vue&type=script&lang=js"
export * from "./UnsubscribeEmailPage.vue?vue&type=script&lang=js"
import style0 from "./UnsubscribeEmailPage.vue?vue&type=style&index=0&id=99ff9fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ff9fd6",
  null
  
)

export default component.exports